import React from 'react'
import {IonSplitPane} from "@ionic/react"

import Menu                from "./components/common/Menu"
import NavBar              from "./components/common/Bars/NavBar"
import RoutesAuthenticated from "./routes/Authenticated"

import PeopleProvider                  from "./contexts/PersonContext"
import KeyProvider                     from "./contexts/KeyContext"
import LockProvider                    from "./contexts/LockContext"
import LockingSystemPermissionProvider from "./contexts/LockingSystemPermissionContext"
import LockingSystemProvider           from "./contexts/LockingSystemContext"
import LockingSystemZoneProvider       from "./contexts/LockingSystemZoneContext"
import UserProvider                    from "./contexts/UserContext"
import TimeLimitProvider               from "./contexts/TimeLimitContext"
import PersonGroupProvider             from "./contexts/PersonGroupContext"
import DataSourceProvider              from "./contexts/DataSourceContext"

const AuthenticatedApp = () => {
    return (
        <>
            <LockingSystemProvider>
            <DataSourceProvider>
            <UserProvider>
            <PeopleProvider>
            <PersonGroupProvider>
            <TimeLimitProvider>
            <KeyProvider>
            <LockProvider>
            <LockingSystemPermissionProvider>
            <LockingSystemZoneProvider>

                <NavBar />
                <IonSplitPane contentId="main">
                    <Menu />
                    <RoutesAuthenticated />
                </IonSplitPane>

            </LockingSystemZoneProvider>
            </LockingSystemPermissionProvider>
            </LockProvider>
            </KeyProvider>
            </TimeLimitProvider>
            </PersonGroupProvider>
            </PeopleProvider>
            </UserProvider>
            </DataSourceProvider>
            </LockingSystemProvider>
        </>
    )
}

export default AuthenticatedApp